import React, { useState } from 'react';
import { Redirect, Link, useParams } from 'react-router-dom';
import update from 'immutability-helper';
import axios from 'axios';

import Validator from 'utils/Validator';

import { Container, Column } from 'components/Layouts/Flow';
import { Form, Input } from 'components/Form';
import Button from 'components/Button';

import Message from 'containers/Authentication/Message';

const Reset = () => {
	// Get user's resetion url
	const { url } = useParams();

	// Cache user's data
	const [data, setData] = useState({
		email: '',
		password: '',
		passwordRepeat: ''
	});

	// Cache error's message
	const [error, setError] = useState('');

	// Cache request progress state
	const [progress, setProgress] = useState(false);

	// Currently ok, but dont like the design
	const [redirect, setRedirect] = useState(false);

	// Handles input's onChange event
	// @event: object | onChange event
	const onChange = event => {
		const { name, value } = event.target;

		// Unset error's message
		setError('');

		// Update field's value
		setData(d => update(d, {
			[name]: {
				$set: value
			}
		}));
	};

	// Handles form's onSubmit event
	// @event: object | onSubmit event
	const onSubmit = event => {
		event.preventDefault();

		// Validate user's data
		Validator.validate('/reset', data);

		// Update error's if there were any
		if (Validator.errors) return setError('Pārliecinaties, vai ievadītie dati ir korekti!');

		// Check if passwords match
		if (data.password !== data.passwordRepeat) return setError('Ievadītās paroles nesakrīt!');

		// Uodate progress state
		setProgress(true);

		// Creates authorization request
		axios({
			method: 'post',
			url: `${process.env.REACT_APP_API}/users/setup`,
			data: {
				url,
				...data
			}
		}).then(() => {
			// Reset progress state
			setProgress(false);

			// Currently ok, but dont like the design
			setRedirect(true);

		}).catch(err => {
			const message = err.response?.data.error;

			// Reset progress state
			setProgress(false);

			if (message === 'validationUrlExpired') {
				// Set error message
				setError('Atjaunošanas saite jau ir izmantota!');
			} else if (message === 'validationUrlIncorrect') {
				// Set error message
				setError('Atjaunošanas saite nav atrasta, dodieties uz e-pastu un nospiediet uz saites vēlreiz!');
			} else if (message === 'validationEmailIncorrect') {
				// Set error message
				setError('Jūsu e-pasts netika atrasts, pārliecinaties vai tas ir ievadīts pareizi!');
			} else {
				// Set error message
				setError('Hmm, kaut kas noticis ar serveri!');
			}
		});
	};

	// Currently ok, but dont like the design
	if (redirect) return <Redirect to="/" />;

	return (
		<div className="authorization__login">
			<Form progress={progress} onSubmit={onSubmit}>
				<Container>
					<Column size="12">
						<h1>Atjaunot paroli</h1>
					</Column>

					<Column size="12">
						<Input
							type="email"
							name="email"
							placeholder="tavs@epasts.lv"
							label="E-pasts"
							icon="mail"
							value={data.email}
							onChange={onChange}
						/>
					</Column>

					<Column size="12">
						<Input
							type="password"
							name="password"
							label="Jaunā parole"
							icon="lock"
							value={data.password}
							onChange={onChange}
						/>
					</Column>

					<Column size="12">
						<Input
							type="password"
							name="passwordRepeat"
							label="Jaunā parole atkārtoti"
							icon="lock"
							value={data.passwordRepeat}
							onChange={onChange}
						/>
					</Column>

					{/* Will be rendered only on error */}
					<Message type="error" message={error} />

					<Column size="12">
						<Link to="/">Pieslēgties</Link>
					</Column>

					<Column size="12">
						<Button submit block text="Atjaunot paroli" />
					</Column>
				</Container>
			</Form>
		</div>
	);
};

export default Reset;
